import styled, {css} from "styled-components";
import { SectionTitle, Section as SectionStyles, SectionSubTitle, Container as ContainerStyles } from "../ReUsableStyles";

export const Section = styled.section`
    ${SectionStyles};
`;

export const Title = styled.h2`
    ${SectionTitle};
    padding-left:0;
    padding-right:0; 
`;

export const Subtitle = styled.span`
    ${SectionSubTitle};
`;

export const Container = styled.div`
    ${ContainerStyles};
    
    display:flex;
    position:relative;
    overflow: hidden;
`;

export const Wrapper = styled.div`
    width:100%;
    display:flex;
    transition: all 1.5s ease;
    transform: translateX(${props => props.slideIndex * -100}vw);

    .content-wrapper{
        width:100vw;
        padding-right: var(--mb-1-5);
        display:flex;
    }
`;

export const Content = styled.div`
    width:100vw;
    height:100%;
`;

export const Data = styled.div`
    display:flex;
    width:100%;
    margin-bottom: var(--mb-1);

    .testimonial__icon-star{
        color: var(--first-color);
    }
    .star-rating{
        align-self: flex-end;
    }
`;

export const TestimonialHeader = styled.div`
    width:100%;
    display:flex;
    .client-details{
        display:flex;
        flex-direction:column;
        justify-content:space-between;
    }
`;

export const Img = styled.img`
    width: 60px;
    height:60px;
    border-radius:50%;
    margin-right: var(--mb-0-75);
`;

export const TestifierName = styled.h3`
    font-size: var(--h3-font-size);
    font-weight: var(--font-medium);
`;

export const TestifierTypeAndRating = styled.span`
    
    display:flex;
    align-items:center;
    justify-content: space-between;
    font-size: var(--small-font-size);
    color: var(--text-color-light);

    .clientType{
        margin-right: var(--mb-1-5);
    }
`;

export const Description = styled.p`
// justify-self:center;
    text-align:center;
    @media screen and (max-width: 568px){
        width:calc(100% - 4rem);
    }  
    margin-bottom: var(--mb-2-5);
`;

export const SlideArrow = styled.div`
    width: 35px;
    height:35px;
    position:absolute;
    color: white;//var(--first-color);
    border-radius: 50%;
    display:flex;
    align-items:center;
    justify-content: center;
    top:;
    bottom:0;
    ${props=>props.right? css`right: 0;`:css`left: 0;`};
    margin:auto;
    background-color: rgba(0,0,0,0.3);
    cursor:pointer;
    z-index: 2;
`;

export const DotsWrapper = styled.div`
    position:absolute;
    bottom:0;
    display:flex;
    right:40%;
`;

export const Dots = styled.span`
    width: 15px;
    height:15px;
    border-radius:50%;
    margin-right: 5px;
    cursor:pointer;
    ${props=>props.slideIndex === props.index - 1 ?
        css`
            background-color:var(--first-color);
        `:css`
            border: 1px solid var(--first-color);
        `};
`;